import { render, staticRenderFns } from "./FarmList.vue?vue&type=template&id=0c74fdeb&"
import script from "./FarmList.vue?vue&type=script&lang=js&"
export * from "./FarmList.vue?vue&type=script&lang=js&"
import style0 from "./FarmList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCol,VDataTable,VImg})
